import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestGridModel } from "../../view-request/request-list/request-list.model";
import { ApiHttpService } from "./api-http.service";

@Injectable()
export class RequestGridService {
    constructor(private apiHttp: ApiHttpService) {}

    public query(criteria: RequestGridQueryCriteria): Observable<PaginatedResult<RequestGridModel>> {
        let params: {
            skip: string;
            take: string;
            sortField: string;
            sortOrder: string;

            requestNumber?: string;
            title?: string;
            statusIds?: string[];
            crop?: string;
            requester?: string;
            tacticalLiaison?: string;
            delegate?: string;
            purposeIds?: string[];
            isSamplingRequired?: string;
            isRecurringRequest?: string;
            plantStartDate?: string;
            plantEndDate?: string;
        } = {
            skip: criteria.skip.toString(),
            take: criteria.take.toString(),
            sortField: criteria.sortField.toString(),
            sortOrder: criteria.sortOrder.toString()
        };

        if (criteria.requestNumber) {
            params.requestNumber = criteria.requestNumber;
        }

        if (criteria.title) {
            params.title = criteria.title;
        }

        if (criteria.statusIds && criteria.statusIds.length > 0) {
            params.statusIds = criteria.statusIds.map(id => id.toString());
        }
      
        if (criteria.requester) {
            params.requester = criteria.requester;
        }

        if (criteria.delegate) {
            params.delegate = criteria.delegate;
        }
    
        if (criteria.tacticalLiaison) {
            params.tacticalLiaison = criteria.tacticalLiaison;
        }
    
        if (criteria.crop) {
            params.crop = criteria.crop;
        }

        if(criteria.purposeIds && criteria.purposeIds.length > 0){
            params.purposeIds = criteria.purposeIds.map(id => id.toString());
        }

        if (criteria.isSamplingRequired !== null && criteria.isSamplingRequired !== undefined) {
            params.isSamplingRequired = criteria.isSamplingRequired.toString();
        }

        if (criteria.isRecurringRequest !== null && criteria.isRecurringRequest !== undefined) {
            params.isRecurringRequest = criteria.isRecurringRequest.toString();
        }
    
        if (criteria.plantStartDate) {
            params.plantStartDate = criteria.plantStartDate.toUTCString();
        }
    
        if (criteria.plantEndDate) {
            params.plantEndDate = criteria.plantEndDate.toUTCString();
        }
      
        return this.apiHttp.get<PaginatedResult<RequestGridModel>>(`requests/grid`, params);
    }
}

export interface PaginatedResult<T> {
    data: T[];
    totalCount: number;
}

export interface RequestGridQueryCriteria {
    skip: number;
    take: number;
    sortField: RequestGridSortField;
    sortOrder: number;

    requestNumber?: string;
    title?: string;
    statusIds?: number[];
    crop?: string;
    requester?: string;
    tacticalLiaison?: string;
    delegate?: string;
    requestPurpose?: string;
    purposeIds?: number[];
    isSamplingRequired?: boolean;
    isRecurringRequest?: boolean;
    plantStartDate?: Date;
    plantEndDate?: Date;
}

export enum RequestGridSortField {
    plantDate = 0,
    requestNumber = 1,
    title = 2
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/request-grid.service.ts